<template>
  <el-row
    v-loading.fullscreen.lock="fullscreenLoading"
    class="pre-wrap"
  >
    <h3>
      {{ $t('preCheckIn.contactInfo.title') }}
    </h3>
    <el-form
      :model="userData"
      :rules="rules"
      ref="contactInfo"
      class="contact-info pre-reg"
      label-position="top"
    >
      <el-row class="block">
        <el-row class="title">
          {{ $t('preCheckIn.contactInfo.title') }}
        </el-row>
        <el-row class="data">
          <el-form-item
            :label="$t('common.labels.mobilePhone')"
            prop="cellPhone"
            :class="[{'focus': userData.cellPhone}, 'is-required']"
          >
            <the-mask
              class="phone"
              mask="(###) ###-####"
              v-model="userData.cellPhone"
            />
          </el-form-item>
          <el-form-item
            :label="$t('common.labels.homePhone')"
            prop="homePhone"
            :class="[{'focus': userData.homePhone}, 'is-required']"
          >
            <the-mask
              class="phone"
              mask="(###) ###-####"
              v-model="userData.homePhone"
            />
          </el-form-item>
        </el-row>
        <el-row class="data">
          <el-form-item
            :label="$t('common.labels.email')"
            prop="email"
            class="is-required"
            :class="[{'focus': userData.email}, 'is-required']"
          >
            <el-input
              type="text"
              v-model="userData.email"
              :value="userData.email"
            />
          </el-form-item>
        </el-row>
      </el-row>
      <el-form-item
        class="submit-container"
      >
        <el-form-item
          class="submit-btn"
        >
          <el-button
            type="primary"
            @click="submitForm('contactInfo')"
          >
            {{ $t('common.buttons.next') }}
          </el-button>
        </el-form-item>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import store from "../../store";

export default {
  name: 'ContactInfo',
  data: () => {
    return {
      user: {},
      fullscreenLoading: false,
      patientNumber: null,
      activeStep: null,
      routerName: 'AddressInfo',
      routerInsuranceSkipName: 'PersonalInfo',
      routerBackName: null,
      sid: null,
      rules: {},
      fields: ['cellPhone', 'homePhone', 'email']
    };
  },
  computed: {
    userData () {
      return this.user;
    }
  },
  watch: {
    'userData.cellPhone': function (val) {
      if (val.trim().length) this.changeField({phone: val});
    },
    'userData.homePhone': function (val) {
      if (val.trim().length) this.changeField({home_phone: val});
    },
    'userData.email': function (val) {
      if (val.trim().length) this.changeField({email: val});
    }
  },
  created () {
    this.fullscreenLoading = true;
    this.setProgressBar();
    this.setRules(this.fields);
    this.activeStep = this.$route.path.substring(1).split('/')[1];
    this.patientNumber = store.getters.patientData.patientNumber;
    this.sid = this.getSessionId();
    if (!this.patientNumber) {
      this.getDataByPatientNumber().then(() => {
        this.user = store.getters.patientData;
        this.patientNumber = this.user.patientNumber;
        this.setData();
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    } else {
      this.user = store.getters.patientData;
      this.setData();
    }
  },
  methods: {
    setData() {
      this.saveStatisticData(this.sid, {
        active_step: this.activeStep,
        render_ContactInfo : 'true'
      });
      this.updateUserAppData(this.userData.patientId, {
        active_pr_step: this.activeStep,
        active_route: this.$route.name
      }).then((response)=> {
        if (response.data.isSuccess) {
          this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/getUserData',{
            pid: this.userData.patientId
          }).then((response) => {
            if (response.data) {
              if (response.data.appData.insurance == 'SELF') {
                this.routerBackName = this.routerInsuranceSkipName;
              }
              this.fullscreenLoading = false;
            }
          }).catch(() => {
            this.setMessage(this.$t('common.errors.data'));
            this.fullscreenLoading = false;
          });
        } else {
          this.fullscreenLoading = false;
        }
      });
    },
    goBack(){
      if (this.routerBackName) {
        this.$router.push({
          name: this.routerBackName,
          params: {
            patientNumber: this.patientNumber
          },
        });
      } else {
        this.$router.go(-1)
      }
    },
    updateUserData() {
      return this.updatePatientInfoData({
        patientId: this.userData.patientId,
        patientNumber: this.patientNumber,
        cellPhone: this.userData.cellPhone,
        homePhone: this.userData.homePhone,
        email: this.userData.email
      }).then((response) => {
        if (response.data.isSuccess) {
          store.dispatch('setPatientData', this.userData);
          this.updateStepsData(this.userData.patientId, {[this.activeStep] : 1}).then((response) => {
            if (response.data.isSuccess) {
              this.updateUserAppData(this.userData.patientId, {
                phone: this.userData.cellPhone,
                hphone: this.userData.homePhone,
                email: this.userData.email
              }).then((response) => {
                if (response.data) {
                  if (response.data.isSuccess) {
                    this.fullscreenLoading = false;
                    this.$router.push({
                      name: this.routerName,
                      params: {
                        patientNumber: this.patientNumber
                      },
                    });
                  } else {
                    this.fullscreenLoading = false;
                    this.setMessage(
                      this.$t('common.errors.update', { type: this.$t('preCheckIn.contactInfo.title').toLowerCase() }),
                      'warning'
                    );
                  }
                }
              }).catch(() => {
                this.$t('common.errors.update', { type: this.$t('preCheckIn.contactInfo.title').toLowerCase() });
                this.fullscreenLoading = false;
              });

            } else {
              this.fullscreenLoading = false;
              this.setMessage(this.$t('common.errors.fail'));
            }
          }).catch(() => {
            this.fullscreenLoading = false;
            this.setMessage(this.$t('common.errors.fail'));
          });
        }
      }).catch(() => {
        this.fullscreenLoading = false;
        this.setMessage(this.$t('common.errors.fail'));
      });
    },
    submitForm(formName) {
      this.fullscreenLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveStatisticData(this.sid, {
            submit_ContactInfo: 'true'
          });
          this.updateUserData();
        } else {
          this.fullscreenLoading = false;
          return false;
        }
      });
    }
  }
};
</script>
